/**
 * found this mixin for auto growing text area when wrapped to nex line
 * Source: https://medium.com/@adamorlowskipoland/vue-auto-resize-textarea-3-different-approaches-8bbda5d074ce
 */
export default {
  methods: {
    mixin_TextAreaResize_resize(event) {
      event.target.style.height = 'auto'
      event.target.style.height = `${event.target.scrollHeight}px`
    },
    mixin_TextAreaResize_findAll() {
      const textareas = document.getElementsByTagName('textarea')
      for (let index = 0; index < textareas.length; index++) {
        textareas[index].dispatchEvent(new Event('input'))
      }
    },
    updateHeight() {
      this.$nextTick(() => {
        this.$el.setAttribute('style', 'height', `${this.$el.scrollHeight}px`)
      })
    },
  },
  updated() {
    this.mixin_TextAreaResize_findAll()
  },
  mounted() {
    this.mixin_TextAreaResize_findAll()
    this.updateHeight()
  },
}
